import { render, staticRenderFns } from "./DropdownActions.vue?vue&type=template&id=bfd99228&scoped=true&"
import script from "./DropdownActions.vue?vue&type=script&lang=js&"
export * from "./DropdownActions.vue?vue&type=script&lang=js&"
import style0 from "./DropdownActions.vue?vue&type=style&index=0&id=bfd99228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd99228",
  null
  
)

export default component.exports